import React from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import "./PlansHeader.css";

export function PlansHeader({ selectPlanDuration, subscriptionType, plan }) {
  return (
    <div
      id={"plan_header"}
      className={"plan_section"}
      style={
        subscriptionType === "yearly" && plan && plan.planId == "plan_3"
          ? { pointerEvents: "none" }
          : {}
      }
    >
      <div className={"subscription-tabs"} style={{ margin: 0 }}>
        <ul className="nav nav-tabs" style={{ width: "max-content" }}>
          <li onClick={() => selectPlanDuration("yearly")}>
            <a className={subscriptionType == "yearly" ? "active" : ""}>
              <FormattedMessage
                id={"billing.billAnnually"}
                values={{
                  span: (chunk) => <span> {chunk} </span>,
                }}
              />
            </a>
          </li>
          <li onClick={() => selectPlanDuration("monthly")}>
            <a className={subscriptionType == "monthly" ? "active" : ""}>
              <FormattedMessage id={"billing.billMonthly"} />
            </a>
          </li>
        </ul>
      </div>
      {/*<div>
        <button className={"buy-credits-pack"} onClick={setCreditPacksModal}>
          <FormattedMessage id={"billing.buyCreditsPack"} />
        </button>
      </div>*/}
    </div>
  );
  return (
    <>
      <Row>
        <Col md={8} className="subscription-tabs">
          <ul className="nav nav-tabs" style={{ width: "max-content" }}>
            <li onClick={() => selectPlanDuration("yearly")}>
              <a className={subscriptionType == "yearly" ? "active" : ""}>
                <FormattedMessage
                  id={"billing.billAnnually"}
                  values={{
                    span: (chunk) => <span> {chunk} </span>,
                  }}
                />
              </a>
            </li>
            <li onClick={() => selectPlanDuration("monthly")}>
              <a className={subscriptionType == "monthly" ? "active" : ""}>
                <FormattedMessage id={"billing.billMonthly"} />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </>
  );
}
